<template>
    <v-container>
      <v-row>
        <v-col
          v-for="(tab, n) in tabs"
          :key="n"
          class="d-flex child-flex"
          cols="12"
          md="6"
        >
          <v-sheet
            class="d-flex"
            :color="tab.color"
          >
            <v-container fill-height>
              <v-row align="center" justify="center">
                <v-col width="100%" hight="100%">
                  <v-sheet contain color="transparent">
                    <button class="pa-12" @click="$router.push(tab.to)"><TextHeading :level=5>{{tab.title}}</TextHeading></button>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  export default {
  
    components: {TextHeading},
  
    data: () => ({
      tabs: [
        {
          title: 'Zarządzanie projektami w tym ich rozliczanie',
          to: '/our_projects/managements',
          color: '#5b9bd5'
        },
        {
          title: 'Przygotowane wnioski o dofinansowanie',
          to: '/our_projects/prepare_funds',
          color: '#52cab8'
        },
        {
          title: 'Audyty i kontrole',
          to: '/our_projects/audits_controls',
          color: '#49bf64'
        },
        {
          title: 'Szkolenia',
          to: '/our_projects/trainings',
          color: '#70ad47'
        }
      ],
    }),
  }
  </script>
  